module.exports = __webpack_public_path__ + "static/media/capitalsphere_sp4.7ca816f9.svg";